import React from "react";
import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  FormHelperText,
} from "@chakra-ui/react";
const Url = ({ options, formik, id }) => {
  const styleClasses =
    options.styleClasses && options.styleClasses.length
      ? options.styleClasses.join(" ")
      : "";
  const urlErrors =
    Object.keys(formik.errors).length &&
    formik.errors.url &&
    formik.errors.url.length &&
    formik.errors.url[id];
  const urlTouched =
    Object.keys(formik.touched).length &&
    formik.touched.url &&
    formik.touched.url.length &&
    formik.touched.url[id];
  const hasError = urlTouched && urlErrors;

  const onChangeurl = (e, id) => {
    const setValues = formik.setValues;
    const formikValues = formik.values;
    const url = [...formik.values.url];
    const currentValues = e.target.value;
    let newUpdateValue = true;
    Object.keys(formikValues.url).some((field, i) => {
      Object.keys(formikValues.url[i]) == e.target.name &&
        (formikValues.url[i][e.target.name] = e.target.value);
      if (
        formikValues.url.length - 1 == i &&
        Object.keys(formikValues.url[i]) == e.target.name
      ) {
        newUpdateValue = false;
      }
      if (!newUpdateValue) {
        return;
      }
    });
    if (newUpdateValue) {
      const currentValuesWithId = {
        [e.target.name]: currentValues,
      };
      url.push(currentValuesWithId);
    }
    setValues({ ...formikValues, url });
  };

  return (
    <FormControl
      className={styleClasses}
      isInvalid={hasError ? true : false}
      mb="2"
      isRequired={options.isRequired}
    >
      {options.showLabel && (
        <FormLabel htmlFor="url" fontSize="14px">
          {options.label}
        </FormLabel>
      )}
      <Input
        size="sm"
        name={`url.${id}.name`}
        type="text"
        placeholder={options.placeholder}
        onChange={(e) => {
          onChangeurl(e, id);
        }}
        value={formik.values && formik.values["url"][`url.${id}.name`]}
      />
      <FormHelperText>{options.helpText}</FormHelperText>
      {hasError ? (
        <FormErrorMessage>{formik.errors.url}</FormErrorMessage>
      ) : null}
    </FormControl>
  );
};

export default Url;
